import { Form, IEditorField, Modal } from 'rewire-ui';
import { ITimeOffRequest } from '../DataTypes';
import { dialogInfoPanelTimeOffRequestViewModel } from './InfoPanelTimeOffRequestViewModel';

interface ITimeOffField {
  field: IEditorField;
  columns: number;
}

interface ITimeOffDetailFields {
  startTime: ITimeOffField;
  endTime: ITimeOffField;
  units: ITimeOffField;
  reason: ITimeOffField;
}

export interface ITimeOffDetailRow {
  id: number;
  isNew: boolean;
  data: ITimeOffDetailFields;
}

class TimeOffDialogModel extends Modal {
  form: Form;
  constructor() {
    super('Create Time Off Request');
    this.action('close')
      .action('clear', this.clear, {
        variant: 'contained',
        color: 'secondary',
        disabled: () => !dialogInfoPanelTimeOffRequestViewModel.isNew,
      })
      .action('save', this.submit, {
        variant: 'contained',
        type: 'submit',
        icon: 'save',
        disabled: () => !dialogInfoPanelTimeOffRequestViewModel.isNew,
      });
  }

  display = async (timeOffRequest: ITimeOffRequest) => {
    dialogInfoPanelTimeOffRequestViewModel.canViewTimeOffBalances = false;
    dialogInfoPanelTimeOffRequestViewModel.load([timeOffRequest], false, undefined);
    this.state.title = 'View Time Off Request';
    this.open();
  };

  open() {
    super.open();
  }

  submit = async () => {
    await dialogInfoPanelTimeOffRequestViewModel.submit();
    this.clear();
    return true;
  };

  clear = async () => {
    dialogInfoPanelTimeOffRequestViewModel.load(undefined, true);
    return false;
    // return dialogInfoPanelTimeOffRequestViewModel.add;
  };

  close = () => {
    this.state.open = false;
    dialogInfoPanelTimeOffRequestViewModel.canViewTimeOffBalances = true;
  };
}

export const timeOffRequestReturnSchema = `
  id
  employee {
    id
    name
  }
  effective
  partialDay
  status
  preference
  comment
  timeOffRanges {
    effective
    units
    reason {
      id
      name
    }
  }
  createdBy
  createdDate
`;

const timeOffDialogModel = new TimeOffDialogModel();
export default timeOffDialogModel;
